import { SetStateAction, useState } from "react"

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { cloneDeep } from 'lodash';
import { Swiper, SwiperSlide } from "swiper/react";

import { settingsInterface } from "../../../app/recipeCreation/createRecipe.types"
import { initialSetting } from '../../../app/recipeCreation/createRecipe.utils';
import { CloseIcon } from "../../../iconRef/recipePageIcons"
import { LeftIcon, RightIcon } from "../../../utils/iconRefs/recipeStepsIcons"
import BladeSpeedPicker from "../utils/bladeSpeedPicker";
import { SPEED, TEMPERATURE, temperatureASCII, TIME } from "../utils/constants";
import getSpeed from "../utils/getSpeedText";
import { getTimeObject } from "../utils/getTime";
import TempraturePicker from "../utils/tempraturePicker";
import TimePicker from "../utils/timePicker";
import { InstructionPopUpMode } from "./instruction.types";
import styles from "./instructionEditPopup.module.css";

const InstructionEditPopup = (
    {
        setSettings,
        settings,
        handleClose,
        editPopUpOpen,
        settingsIndexToEdit,
        setSettingsIndexToEdit,
        selectedEditMode,
        setSelectedEditMode,
        instructionModalMode,
        setInstructionModalMode,
    }: {
        setSettings: React.Dispatch<SetStateAction<Array<settingsInterface>>>,
        settings: Array<settingsInterface>,
        handleClose: () => void,
        editPopUpOpen: boolean,
        settingsIndexToEdit: number,
        setSettingsIndexToEdit: React.Dispatch<SetStateAction<number>>,
        selectedEditMode: string,
        setSelectedEditMode: React.Dispatch<SetStateAction<string>>,
        instructionModalMode: string | null,
        setInstructionModalMode: React.Dispatch<SetStateAction<string | null>>,
    }
) => {
    const [swiperInstance, setSwiperInstance] = useState<any>(null)
    const [localSetting, setLocalSetting] = useState(instructionModalMode === InstructionPopUpMode.ADD ? cloneDeep([initialSetting]) : cloneDeep(settings))
    const onDone = () => {
        instructionModalMode === InstructionPopUpMode.ADD ? setSettings([...settings, ...localSetting]) : setSettings(localSetting)
        handleClose()
    }
    // Todo - Fix pwa textfield onclose issue
    return (
        <Dialog fullWidth onClose={handleClose} open={editPopUpOpen}
            PaperProps={{ className: styles.popup_dialog }}>
            <Box className={styles.popup_dialog_container}>
                <Box className={styles.popup_close_icon} >
                    <CloseIcon onClick={handleClose} />
                </Box>
                <Box className={styles.popup_title}>
                    {instructionModalMode === InstructionPopUpMode.EDIT && <Box className={styles.popup_nav_icon} onClick={() => swiperInstance.slidePrev()}>
                        <LeftIcon />
                    </Box>}
                    <Typography variant="caption">Instruction {instructionModalMode === InstructionPopUpMode.ADD ? settings.length + 1 : settingsIndexToEdit + 1}</Typography>
                    {instructionModalMode === InstructionPopUpMode.EDIT && <Box className={styles.popup_nav_icon} onClick={() => swiperInstance.slideNext()}>
                        <RightIcon />
                    </Box>}
                </Box>
                <Swiper
                    allowTouchMove={false}
                    className={styles.swiper_container}
                    initialSlide={settingsIndexToEdit}
                    loop
                    onSwiper={(swiper) => setSwiperInstance(swiper)}
                    onTransitionEnd={(swiper) => {
                        setSettingsIndexToEdit(swiper.realIndex)
                    }}
                >
                    {localSetting.map((setting: settingsInterface, index: number) => {
                        const { mins, secs } = getTimeObject(setting.time)
                        return (
                            <SwiperSlide>
                                <Box className={styles.swiper_slide_container}>
                                    {selectedEditMode !== TIME ?
                                        <Box className={styles.instruction_edit_container} onClick={() => { setSelectedEditMode(TIME); }}>
                                            <Typography variant="caption3Light">Time</Typography>
                                            <Box className={styles.instruction_time_container}>
                                                <Typography variant="caption3Bold">{mins}</Typography>
                                                <Typography variant="caption3Light">m</Typography>
                                                <Typography variant="caption3Bold">:</Typography>
                                                <Typography variant="caption3Bold">{secs}</Typography>
                                                <Typography variant="caption3Light">s</Typography>
                                            </Box>
                                        </Box> :
                                        <Box className={styles.instruction_edit_layout}>
                                            <Typography variant="caption3Light">Time</Typography>
                                            <TimePicker index={index} localSetting={localSetting} timeValue={setting.time} />
                                        </Box>
                                    }
                                    {selectedEditMode !== SPEED ?
                                        <Box className={styles.instruction_edit_container} onClick={() => { setSelectedEditMode(SPEED); }}>
                                            <Typography variant="caption3Light">Blade Speed</Typography>
                                            <Typography variant="caption3Bold">{getSpeed(setting.speed)}</Typography>
                                        </Box> :
                                        <Box className={styles.instruction_edit_layout}>
                                            <Typography variant="caption3Light">Blade Speed</Typography>
                                            <BladeSpeedPicker index={index} localSetting={localSetting} speedValue={setting.speed} />
                                        </Box>
                                    }
                                    {selectedEditMode !== TEMPERATURE ?
                                        <Box className={styles.instruction_edit_container} onClick={() => { setSelectedEditMode(TEMPERATURE); }}>
                                            <Typography variant="caption3Light">Temperature</Typography>
                                            <Typography variant="caption3Bold">{setting.temperature + temperatureASCII}C</Typography>
                                        </Box> :
                                        <Box className={styles.instruction_edit_layout}>
                                            <Typography variant="caption3Light">Temperature</Typography>
                                            <TempraturePicker index={index} localSetting={localSetting} tempratureValue={setting.temperature} />
                                        </Box>
                                    }
                                </Box>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
                <Button className={styles.settings_done_button} onClick={onDone}>
                    <Typography variant="body5">Done</Typography>
                </Button>
            </Box>
        </Dialog >
    )
}
export default InstructionEditPopup